import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth';
import notifications from './modules/notifications';

// Create store
const store = createStore({
    modules: {
        auth,
        notifications
    },
    // Solo `auth` se persiste (como antes). `notifications` no: el historial se re-trae en cada
    // arranque y el estado de leído vive en su propia clave de localStorage por usuario.
    plugins: [createPersistedState({ paths: ['auth'] })]
})

export default store